/* 🤖 this file was generated by svg-to-ts */
export const DfIconPaperclip16: {
  name: 'paperclip-16';
  data: string;
} = {
  name: 'paperclip-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M7.22 8.905a.487.487 0 0 0-.046.658.421.421 0 0 0 .62.02l3.67-3.504c.736-.704.82-1.882.185-2.631s-1.745-.786-2.482-.082L4.831 7.508c-1.29 1.232-1.435 3.293-.325 4.604s3.054 1.375 4.344.143l4.002-3.823L14 9.788l-4.002 3.824c-2.026 1.935-5.083 1.835-6.826-.225-1.744-2.06-1.515-5.3.511-7.235L8.019 2.01c1.473-1.408 3.696-1.335 4.964.163 1.268 1.499 1.102 3.854-.372 5.262L8.943 10.94c-.921.88-2.31.834-3.103-.102-.793-.937-.689-2.41.232-3.289l3.002-2.868 1.148 1.357z" fill-rule="evenodd"/></svg>`
};
